import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import translations from '../translations';
import Footer from './Footer';
import './Aboutus.css';
import logoImage from '../assets/Logo.png';
import {
  MdSecurity,
  MdEngineering,
  MdBusinessCenter,
  MdPeople,
  MdAccountBalance,
  MdSupportAgent,
} from 'react-icons/md';
import { GiCyberEye } from 'react-icons/gi';

const Aboutus = () => {
  const navigate = useNavigate();
  const { lang } = useLanguage();
  const t = translations[lang];
  const isRTL = lang === 'ar';

  const capabilities = [
    { icon: <MdSecurity size={36} />, title: t.cap_soc_t, desc: t.cap_soc_d },
    { icon: <MdEngineering size={36} />, title: t.cap_net_t, desc: t.cap_net_d },
    { icon: <GiCyberEye size={36} />, title: t.cap_sec_t, desc: t.cap_sec_d },
    { icon: <MdSupportAgent size={36} />, title: t.cap_netscout_t, desc: t.cap_netscout_d },
    { icon: <MdBusinessCenter size={36} />, title: t.cap_pm_t, desc: t.cap_pm_d },
    { icon: <MdPeople size={36} />, title: t.cap_hr_t, desc: t.cap_hr_d },
    { icon: <MdAccountBalance size={36} />, title: t.cap_fin_t, desc: t.cap_fin_d },
  ];

  return (
    <div className="bg-[#111820] text-[#97d700] font-sans leading-normal tracking-normal" dir={isRTL ? 'rtl' : 'ltr'}>
      <Helmet>
        <title>{isRTL ? 'من نحن — Technology Resources' : 'About Us — Technology Resources'}</title>
        <meta name="description" content={isRTL ? 'تعرّف على شركة Technology Resources، الرائدة في الأمن السيبراني في العراق بالشراكة مع NETSCOUT Arbor.' : "Learn about Technology Resources (TR), Iraq's leading cybersecurity company specializing in anti-DDoS solutions in partnership with NETSCOUT Arbor."} />
      </Helmet>
      <div className="video-header" onClick={() => navigate('/')}>
        <video autoPlay loop muted className="background-video">
          <source src="/assets/cybernet.mp4" type="video/mp4" />
        </video>
        <div className="overlay"></div>
        <div className="header-content">
          <img src={logoImage} alt="Technology Resources Logo" className="header-logo" />
          <h1 className="header-title font-magistral">Tech Resources</h1>
        </div>
      </div>

      <div className={`container mx-auto p-4 ${isRTL ? 'font-arabic' : ''}`}>
        <h2 className="text-2xl font-bold">{t.about_who_title}</h2>
        <p className="text-base mt-3">{t.about_who_body}</p>
        <h2 className="text-2xl font-bold mt-4">{t.about_what_title}</h2>
        <p className="text-base mt-3">{t.about_what_body}</p>
        <h2 className="text-2xl font-bold mt-4">{t.about_join_title}</h2>
        <p className="text-base mt-3 mb-12">{t.about_join_body}</p>

        <h2 className="text-2xl font-bold mb-4">{t.team_title}</h2>
        <p className="text-base text-gray-400 mb-8">{t.team_subtitle}</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {capabilities.map((cap) => (
            <div
              key={cap.title}
              className="bg-[#1a2530] rounded-xl p-6 hover:scale-105 transition-transform duration-300 text-center"
            >
              <div className="text-[#97d700] flex justify-center mb-4">{cap.icon}</div>
              <h3 className="text-white text-lg font-bold mb-2">{cap.title}</h3>
              <p className="text-gray-400 text-sm">{cap.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Aboutus;
